export const PAGE_API_LOADING = 'PAGE_API_LOADING'

export const SET_BOT_LIST = 'SET_BOT_LIST'
export const SET_AI_BOT_ID = 'SET_AI_BOT_ID'
export const RESET_STATE_AI_BOT = 'RESET_STATE_AI_BOT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js